<div *ngIf="crmItem" class="crm-item-details-parent justify-content-between">
  <div *ngIf="crmView" class="crm-item-details-header">
    <div>
      <h1 class="crm-item-details-title">
        {{ crmItem.name }}
      </h1>
      <h2>
        {{ crmItem.summary }}
      </h2>
      <div class="d-flex" *ngIf="crmItem.companies[0]">
        <a [href]="'/company/' + (crmItem.companies && crmItem.companies[0]?.company.id)" target="_blank">{{ crmItem.companies[0].company.name }}</a>
        <ng-container *ngIf="!crmItem.nonDeal">
          <div class="mx-1">|</div>
          <div>{{ crmItem.dealTypes | rmsMap:getDealTypeLabel | rmsJoin }}</div>
        </ng-container>
      </div>
    </div>

    <div class="crm-item-details-content-block-buttons">
      <div *ngIf="crmView && !crmItem.archived" class="d-flex">
        <i class="fa fa-pencil" (click)="editCrmItem()"></i>
        <div class="btn archive-button" (click)="openArchiveModal()">{{ "GENERICS.ARCHIVE" | translate }}</div>
      </div>
      <div *ngIf="!crmView && !crmItem.archived" class="d-flex">
        <i class="fa fa-pencil" (click)="editCrmItem()"></i>
      </div>
    </div>
  </div>

  <div class="crm-item-details-content-parent pt-3 px-3" (click)="isOpen = !isOpen">
    <div class="mx-2" *ngIf="!crmItem.nonDeal">
      <i class="fa fa-2x caret" [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
    </div>
    <div class="crm-item-details-content w-75 justify-content-between">
      <div class="crm-item-details-content-block margin-right">
        <div *ngIf="!crmView" class="block-text">{{ "CRM.NAME" | translate }}: <a [routerLink]="CRM_ITEM_ROUTE + crmItem.id" target="_blank" (click)="$event.stopPropagation()">{{ crmItem.name }}</a></div>
        <div *ngIf="!crmView" class="block-text">{{ "CRM.SUMMARY" | translate }}: <span>{{ crmItem.summary }}</span></div>
        <div class="block-text">{{ "CRM.PRIORITY" | translate }}: <span>{{ crmItem.priority }}</span></div>
        <div *ngIf="!crmItem.nonDeal" class="block-text">{{ "CRM.STRUCT_CAP.TOTAL_DEAL_SIZE" | translate }}: <span class="mr-3">${{ crmItem.totalDealSize }}M</span> {{ "CRM.STRUCT_CAP.RA_DEAL_SIZE" | translate }}: <span>${{ crmItem.raDealSize }}M</span></div>
        <div *ngIf="!crmItem.nonDeal" class="block-text">{{ "CRM.STRUCT_CAP.DEAL_SOURCE_TYPE" | translate }}: <span>{{ StructCapDealSourceTypeLabels[crmItem.dealSourceType] }}</span></div>
        <div *ngIf="!crmItem.nonDeal" class="block-text">{{ "CRM.STRUCT_CAP.SOURCED_BY" | translate }}: <span>{{ getSourceUsers() }}</span></div>
        <div *ngIf="!crmItem.nonDeal" class="block-text">{{ "CRM.STRUCT_CAP.SOURCE_CONTACT" | translate }}: <span>{{ crmItem.dealSourceContact }}</span></div>
      </div>

      <div class="crm-item-details-content-block">
        <div *ngIf="!crmView && !crmItem.nonDeal" class="block-text">{{ "CRM.STRUCT_CAP.DEAL_TYPE" | translate }}: <span>{{ crmItem.dealTypes | rmsMap:getDealTypeLabel | rmsJoin }}</span></div>
        <div class="block-text">{{ "CRM.DILIGENCE_LEAD" | translate }}: <span>{{ crmItem.leader?.user.fullName }}</span></div>
        <div class="block-text">{{ "CRM.STRUCT_CAP.TEAM" | translate }}: <span>{{ getParticipants() }}</span></div>
        <div class="block-text">{{ "GENERICS.DATE_CREATED" | translate }}: <span>{{ crmItem.created | date:'MM/dd/yyyy' }}</span></div>
      </div>
    </div>
    <div class="crm-item-details-content justify-content-center w-25" *ngIf="!crmItem.nonDeal">
      <div class="d-flex flex-column align-items-center">
        <rms-bubble-icon [icon]="'check'" [color]="RMS_PRIMARY_COLOR" class="mb-2"></rms-bubble-icon>
        <div class="bold">{{ crmStatusService.getStatusLabel(crmItem) }}</div>
        <div *ngIf="BLOCKING_STATUSES.includes(crmItem.status)" style="font-size: 11px">{{ StructCapStatusReasonLabels[crmItem.statusReason] }}</div>
      </div>
    </div>
    <div *ngIf="!crmView && !crmItem.archived" class="crm-item-details-content ml-auto">
      <div class="crm-item-details-content-block">
        <div class="crm-item-details-content-block-buttons ml-2">
          <i (click)="openCrmHistory(crmItem); $event.stopPropagation()" class="fa fa-history pull-right crm-history-button"></i>
          <i class="fa fa-pencil" (click)="editCrmItem()"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="crm-item-details-content-parent" *ngIf="!crmItem.nonDeal">
    <div *ngIf="isOpen" style="gap: 20px; font-size: 13px" class="w-100">
      <div class="crm-item-details-content crm-item-details-display w-75 pb-0">
        <div class="d-flex flex-column">
          <div class="block-text">{{ "CRM.STRUCT_CAP.PRIV/PUBLIC" | translate }}: <span class="bold">{{ (crmItem.companies && crmItem.companies[0]?.company.isPrivate ? "GENERICS.PRIVATE" : "GENERICS.PUBLIC") | translate }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.COMPANY_STAGE" | translate }}: <span class="bold">{{ CompanyStageLabels[crmItem.companyStage] || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.HEALTHCARE_SUBSECTOR" | translate }}: <span class="bold">{{ HealthcareSubsectorLabels[crmItem.healthcareSubSector] || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.DISEASE_FOCUS" | translate }}: <span class="bold">{{ crmItem.diseaseFocus || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.LOCATION" | translate }}: <span class="bold">{{ crmItem.location || '--' }}</span></div>
        </div>
        <div class="d-flex flex-column">
          <div class="block-text">{{ "CRM.STRUCT_CAP.REVENUE_MODEL" | translate }}: <span class="bold">{{ crmItem.revenueModel || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.DOWNSIDE_SUPPORT" | translate }}: <span class="bold">{{ crmItem.downsideSupport || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.NDA_SIGNED" | translate }}: <span class="bold">{{ crmItem.ndaSigned ? 'Yes' : 'No' }}</span><span *ngIf="crmItem.ndaSigned && crmItem.ndaExpiration"> (Exp. {{ (crmItem.ndaExpiration | date:'MM/dd/yyyy') || '--' }})</span></div>
        </div>
        <div class="d-flex flex-column">
          <div class="block-text">{{ "CRM.STRUCT_CAP.CURRENT_ROUND_VALUATION" | translate }}: <span class="bold">${{ crmItem.currentRoundValuation || '--' }}M</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.LAST_ROUND_VALUATION" | translate }}: <span class="bold">${{ crmItem.lastRoundValuation || '--' }}M</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.EXPECTED_MOIC" | translate }}: <span class="bold">{{ crmItem.expectedMoic || '--' }}x</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.EXPECTED_IRR" | translate }}: <span class="bold">{{ crmItem.expectedIrr || '--' }}%</span></div>
        </div>
        <div class="d-flex flex-column">
          <div class="block-text">{{ "CRM.STRUCT_CAP.LTM_REVENUE" | translate }}: <span class="bold">${{ crmItem.ltmRevenue || '--' }}</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.LTM_EBITDA" | translate }}: <span class="bold">(${{ crmItem.ltmEbitda || '--' }})</span></div>
          <div class="block-text">{{ "CRM.STRUCT_CAP.CAP_IQ" | translate }}: <span class="bold">{{ crmItem.capIqId || '--' }}</span></div>
        </div>
      </div>
      <div class="crm-item-details-content crm-item-details-display w-100 mt-2 pt-0">
        <div class="block-text d-flex flex-column">{{ "CRM.STRUCT_CAP.DESCRIPTION" | translate }}: <span class="bold">{{ crmItem.description || '--' }}</span></div>
      </div>
    </div>
  </div>
  <div class="crm-item-details-content-parent" *ngIf="!crmItem.nonDeal">
    <div *ngIf="isOpen" class="crm-item-details-content crm-item-details-display w-100">
      <div class="crm-item-details-timeline w-100" style="border-bottom: none">
        <rms-bubble-timeline [currentStageOnly]="false" [currentStage]="crmStatusService.getCurrentStage(crmItem)" [stages]="crmStatusService.getStages()" [vertical]="belowBreakpoint()"></rms-bubble-timeline>
      </div>
    </div>
  </div>
</div>
